// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"49fa3ddf","79":"6ded8f59","391":"49cde465","397":"5d334635","466":"89b028ae","533":"62eae0a2","879":"87a05ef1","881":"6f58db33","885":"1c4f3f54","930":"9d94ddb0","998":"b3245fcc"}[chunkId] + ".chunk.js";
};